/**
 * OldOffer component.
 */
define([
        'jQuery',
        'underscore',
        'library/fcse-compatibility/object',
        'library/fcse-component/optionsMixin',
        'library/fcse-events/eventDispatcher',
    ],
    function ($, _, Object, OptionsMixin, EventDispatcher) {

        /**
         * OldOffer constructor
         *
         * @param {jQuery} element
         * @param requestHandler
         * @param options
         * @constructor
         */
        var OldOffer = function (element, requestHandler, options) {
            // Set default options
            var defaultOptions = {
                loadingClass: 'is-loading'
            };

            // Cause of a bug in top level implementation
            if (element.length > 1) {
                element = element.last();
            }
            this.element = element;

            // Save local variables
            this.requestHandler = requestHandler;
            this.initialRouteParams = this.element.data("initial-route-params");
            this.addOptions(defaultOptions, options);
            this.showOldPrice = this.element.closest('[data-fcse-role="offerlist"]').data('show-old-price');

            this._initLoadingEvents();
            this._init();
        };

        OldOffer.prototype = $.extend(Object.create(EventDispatcher.prototype), Object.create(OptionsMixin), {
            /**
             * Initialize OldOffer
             *
             * @private
             */
            _init: function () {
                if (!_.isUndefined(this.showOldPrice) && this.showOldPrice !== 1) {
                    return false;
                }

                this.element.find('[data-fcse-role="price-pp"]').filter(function () {
                  return !$(this).closest('[data-fcse-role="offervaliditybar"]').length;
                }).addClass(this.option('loadingClass'));

                this.requestHandler.send(this.option('oldPriceRoute'), {
                    requestId: this.element.data('fcse-request-id'),
                    productSearchId: this.element.data('fcse-product-search-id')
                }, this.initialRouteParams);
            },

            /**
             * Initialize Loading Events
             *
             * @private
             */
            _initLoadingEvents: function () {
                this.requestHandler.on('success', $.proxy(this._onLoadContentSuccess, this));
                this.requestHandler.on('error', $.proxy(this._onLoadContentError, this));
            },

            /**
             * Handler for content loading success
             *
             * @param data
             * @param requestData
             * @protected
             */
            _onLoadContentSuccess: function (data, requestData) {
                // Check if ajax response is from oldPriceRoute
                if (requestData.route == this.option('oldPriceRoute')) {
                    // Unset loading state
                    this.element.find('[data-fcse-role="price-pp"]').removeClass(this.option('loadingClass'));
                    this.element.find('[data-fcse-role="old-offer-price"]').each(function (index, element) {
                        const badgeEl = $(element)
                            .closest('[data-fcse-role="offer-item"]')
                            .find('[data-fcse-role-placeholder="badge-placeholder"]');
                        badgeEl.replaceWith(
                            $(data[index]).find('[data-fcse-role="campaign-badge-async"]').html()
                        );
                        $(element).replaceWith($(data[index]).find('[data-fcse-role="price-pp-async"]').html());
                    });
                }
            },

            /**
             * Handler for content loading error
             * @param event
             * @private
             */
            _onLoadContentError: function (event) {
                this.element.find('[data-fcse-role="price-pp"]').removeClass(this.option('loadingClass'));
            }
        });

        return OldOffer;
    }
);


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/oldoffer/oldOffer.js